var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-sheet',{attrs:{"inset":"","max-width":"400px","scrollable":""},model:{value:(_vm.upgradeStore.upgrade),callback:function ($$v) {_vm.$set(_vm.upgradeStore, "upgrade", $$v)},expression:"upgradeStore.upgrade"}},[_c('UpgradeCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }